var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#34F32A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5122C24.271 11.9636 25.4248 12.6939 26.3766 13.6497C27.3283 14.6054 28.0539 15.7623 28.5 17.0352M19 11.0552C17.4831 11.2245 16.0341 11.7768 14.7894 12.6602C13.5447 13.5435 12.5451 14.729 11.8846 16.105C11.2241 17.481 10.9244 19.0023 11.0137 20.526C11.103 22.0498 11.5783 23.5257 12.395 24.8152L11 29.0002L15.185 27.6052C16.4744 28.4218 17.9504 28.8972 19.4741 28.9864C20.9978 29.0757 22.5192 28.776 23.8952 28.1155C25.2712 27.455 26.4566 26.4554 27.34 25.2107C28.2234 23.966 28.7757 22.5171 28.945 21.0002",
    stroke: "#34F32A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25C18.6739 25 17.4021 24.4732 16.4645 23.5355C15.5268 22.5979 15 21.3261 15 20M17 16C17.9629 15.2779 19.1539 14.9273 20.3544 15.0126C21.555 15.0979 22.6845 15.6134 23.5355 16.4645C24.3866 17.3155 24.9021 18.445 24.9874 19.6456C25.0727 20.8461 24.7221 22.0371 24 23",
    stroke: "#34F32A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21Z",
    stroke: "#34F32A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.1f10cba9ebe5f513dcd07d356607bd93.svg";
export { ForwardRef as ReactComponent };